var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.9V16.2L14.4737 9.45V2.025C14.4737 0.9045 13.5921 0 12.5 0C11.4079 0 10.5263 0.9045 10.5263 2.025V9.45L0 16.2V18.9L10.5263 15.525V22.95L7.89474 24.975V27L12.5 25.65L17.1053 27V24.975L14.4737 22.95V15.525L25 18.9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlights);
export default __webpack_public_path__ + "static/media/flights.71cadbde90fecbda8f7f3b9ccd04af82.svg";
export { ForwardRef as ReactComponent };